import React from "react";
import "./Styles/AddNewEvent.css";
import EventGrid from "./EventGrid";
const AllEvents = () => {
  return (
    <>
      <div className="add-new-course-grid">
        <EventGrid />
      </div>
    </>
  );
};

export { AllEvents };
